export default __webpack_public_path__ + "static/media/uk.d79e2801.png";